<template>
  <el-dialog
    :title="title"
    :visible.sync="addRewardsAndAssessmentVisible"
    class="small-dialog"
    v-dialogDrag
    :before-close="cancel"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form ref="rewardsAndAssessmentRef" label-width="150px" :model="rewardsAndAssessmentForm">
      <el-form-item
        label="奖励情况"
        prop="reward"
        :rules="[
          {
            required: true,
            message: '请输入奖励情况',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="rewardsAndAssessmentForm.reward"
          maxlength="30"
          placeholder="请输入奖励情况"
        />
      </el-form-item>
      <el-form-item
        label="考核情况"
        prop="assessment"
        :rules="[
          {
            required: true,
            message: '请输入考核情况',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="rewardsAndAssessmentForm.assessment"
          maxlength="30"
          placeholder="请输入考核情况"
        />
      </el-form-item>
      <el-form-item
        label="其它情况"
        prop="other"
        :rules="[
          {
            required: true,
            message: '请输入其它情况',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="rewardsAndAssessmentForm.other"
          maxlength="30"
          placeholder="请输入其它情况"
        />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="rewardsAndAssessmentForm.remark"
          maxlength="50"
          type="textarea"
          rows="3"
          placeholder="请输入备注"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="flex justify-center">
      <el-button size="small" type="primary" @click="save" :loading="loading">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { ContractorApi } from '@wiz-api/contractor-management'

const contractorApi = new ContractorApi()
export default {
  model: {
    prop: 'addRewardsAndAssessmentVisible',
    event: 'addRewardsAndAssessmentChange',
  },
  props: {
    addRewardsAndAssessmentVisible: {
      type: Boolean,
      default: false,
    },
    contractorId: {
      type: String,
      default: '',
    },
    saveRewardAndAssessmentRow: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: '上传考核情况',
      loading: false,
      rewardsAndAssessmentForm: {},
      taskFrequencyType: [],
      workPermitCategoryList: [],
    }
  },
  watch: {
    saveRewardAndAssessmentRow(val) {
      if (val.id) {
        this.rewardsAndAssessmentForm = val
        this.title = '编辑考核情况'
      }
    },
  },
  methods: {
    fileIdChange(key) {
      this.$refs[key].$emit('el.form.change')
    },
    cancel() {
      this.rewardsAndAssessmentForm = {}
      this.$refs.rewardsAndAssessmentRef.resetFields()
      this.$emit('addRewardsAndAssessmentChange', false)
    },
    save() {
      this.$refs.rewardsAndAssessmentRef.validate(async (valid) => {
        if (valid) {
          this.loading = true
          if (!this.saveRewardAndAssessmentRow?.id) {
            const [err, res] = await contractorApi.createRewardAndAssessment(this.contractorId, {
              body: this.rewardsAndAssessmentForm,
            })
            if (!err) {
              this.$message.success('上传成功')
              this.cancel()
            }
          } else {
            const [err, res] = await contractorApi.updateRewardAndAssessment(
              this.contractorId,
              this.saveRewardAndAssessmentRow.id,
              {
                body: this.rewardsAndAssessmentForm,
              }
            )
            if (!err) {
              this.$message.success('编辑成功')
              this.cancel()
            }
          }

          this.loading = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-dragger {
  height: 130px !important;
  width: 440px !important;
  .el-icon-upload {
    margin: 18px 0 16px;
  }
}
</style>
